import React from "react";
import { Tooltip as ChakraTooltip, TooltipProps } from "@chakra-ui/react";

/**
 * Module-standard tooltip — the ONE copy of the defaults that stop tooltips
 * sticking on a page that scrolls and re-renders constantly (the 2026-08-10
 * "tooltips lag and stay there" hardening pass):
 *
 * - `closeOnScroll` — Chakra defaults this OFF. The calendar scrolls all the
 *   time (grid scroll, fit-mode instant scroll, goals board), so an open
 *   tooltip stayed anchored mid-air after its trigger scrolled away.
 * - `openDelay={300}` — the platform canonical delay. Without it a tooltip
 *   opens on pointer TRANSIT (every toolbar hover-through flashed one).
 * - `hasArrow` + `placement="top"` — the platform canonical shape.
 *
 * Every calendars-module file imports `Tooltip` from HERE, not from Chakra, so
 * the fix can never be forgotten site-by-site. All props stay overridable per
 * site (spread comes last). Do not add behaviour here that any single site
 * needs — override at that site instead.
 */
export const Tip: React.FC<TooltipProps> = (props) => (
    <ChakraTooltip hasArrow openDelay={300} placement="top" closeOnScroll {...props} />
);

// Alias so existing `<Tooltip>` JSX keeps working with only an import swap.
export { Tip as Tooltip };
